export default __webpack_public_path__ + "a30d3898fd5f369cb7e7f332e1bc1820.svg";